import { api } from '../api';
import type { BalancaDoEnsaio } from './triviais';

/**
 * As chamadas da massa específica dos sólidos, com os caminhos escritos
 * por extenso — o teste `26` precisa enxergar a string literal.
 */

/**
 * De onde veio M₁ (RN-259): lido na curva do picnômetro, declarado à mão
 * (exceção), temperatura fora da faixa medida, ou picnômetro sem curva
 * vigente na data. Os dois últimos travam o resultado.
 */
export type OrigemDeM1 = 'curva' | 'declarada' | 'fora_da_faixa' | 'sem_curva';

/** A linha de `vw_mes_determinacao` como a API a devolve. */
export interface DeterminacaoDaMes {
  id: string;
  ordem: number;
  picnometro: string | null;
  m1_origem: OrigemDeM1;
  massa_picnometro_agua: number | string | null;
  agua_massa_especifica: number | string | null;
  certificado_m1: string | null;
  motivo_m1_declarado: string | null;
  m1_curva_id: string | null;
  m1_curva_versao: number | null;
  m1_curva_x_min: number | string | null;
  m1_curva_x_max: number | string | null;
  [campo: string]: any;
}

/**
 * Uma determinação a gravar. M₁ declarado vai com o certificado e o
 * motivo, e só passa para quem tem `ensaio.corrigir_lancamento`.
 */
export interface DeterminacaoParaGravar {
  ordem: number;
  picnometroEquipamentoId: string;
  massaAmostraUmida: number;
  massaPicnometroSoloAgua: number;
  temperatura: number;
  massaPicnometroAguaDeclarada?: number;
  certificadoM1?: string;
  motivoM1?: string;
}

export interface EnsaioMassaEspecifica {
  cabecalho: any;
  determinacoes: DeterminacaoDaMes[];
  umidades: any[];
  equipamentos: any[];
  /** A balança das pesagens do picnômetro (RN-215). */
  balanca: BalancaDoEnsaio | null;
  /** A balança da umidade da amostra — outra bateria, outra escolha. */
  balancaUmidade: BalancaDoEnsaio | null;
  pendenciasDetalhadas?: any[];
  pendencias: string[];
  /** A tentativa aberta pela repetição (onda 323), ou `null`. */
  repeticaoAberta?: number | null;
}

export const verMassaEspecifica = (id: string) =>
  api<EnsaioMassaEspecifica>(`/ensaios/${id}/massa-especifica`);

export const gravarMassaEspecificaCabecalho = (id: string, corpo: unknown) =>
  api<EnsaioMassaEspecifica>(`/ensaios/${id}/massa-especifica`,
    { metodo: 'PUT', corpo });

export const gravarMassaEspecificaDeterminacoes = (
  id: string, corpo: unknown,
) =>
  api<EnsaioMassaEspecifica>(`/ensaios/${id}/massa-especifica/determinacoes`,
    { metodo: 'POST', corpo });

export const descartarMassaEspecificaDeterminacao = (
  id: string, did: string, motivo: string,
) =>
  api<EnsaioMassaEspecifica>(
    `/ensaios/${id}/massa-especifica/determinacoes/${did}/descartar`,
    { metodo: 'POST', corpo: { motivo } });

export const gravarMassaEspecificaUmidades = (id: string, corpo: unknown) =>
  api<EnsaioMassaEspecifica>(`/ensaios/${id}/massa-especifica/umidades`,
    { metodo: 'POST', corpo });

export const descartarMassaEspecificaUmidade = (
  id: string, uid: string, motivo: string,
) =>
  api<EnsaioMassaEspecifica>(
    `/ensaios/${id}/massa-especifica/umidades/${uid}/descartar`,
    { metodo: 'POST', corpo: { motivo } });
